module.exports = __webpack_public_path__ + "f8444922504722b76229c91dfa85878f.jpg";